import { Component } from 'preact'
import WidgetPreview from '../components/widget-preview'
import {
    LayoutFilter,
    BackgroundFilter,
    LinkFilter,
    ReviewItemFrameFilter,
    ItemBackgroundFilter,
    OuterWrapperFrameFilter,
    MinimalRatingFilter
} from '../components/filters'
import { __ } from '../../locales'

class WfGrid extends Component {
    state = {
        selectedLayout: 'layoutA',
        layoutOptions: [
            {
                label: 'Grid Layout A',
                value: 'layoutA'
            },
            {
                label: 'Grid Layout B',
                value: 'layoutB'
            },
        ]
    };

    render(props, state) {
        return (
            <WidgetPreview
                {...props}
                name={__('widget.review_grid.name')}
                description={__('widget.review_grid.description')}
                bestFor={[__('global.homepage'), __('global.footer')]}
                type={'grid-widget'}
                extraParams={[
                    'slugs',
                    'linkUrl',
                    'background',
                    'itemBackground',
                    'outerFrame',
                    'itemFrame',
                    'rating',
                ]}
                layoutType={state.selectedLayout}
                badgeTitle={__('widget.type.carousel')}
                badgeColor={'#2B59E0'}
                badgeFontColor={'#FFFFFF'}
            >
                <div className={'filters-wrapper mt-5 mb-5'}>
                    <LinkFilter
                        {...props}
                        hidden={props.inputs?.profileType === 'specialist' && props.selectedProfiles?.length <= 1}
                    />
                    <LayoutFilter
                        selectedLayout={state.selectedLayout}
                        options={state.layoutOptions}
                        onChange={ev => this.setState({ selectedLayout: ev.target.value })}
                    />
                    <BackgroundFilter {...props} />
                    <MinimalRatingFilter {...props} />
                    <ItemBackgroundFilter {...props} />
                    <ReviewItemFrameFilter {...props} />
                    <OuterWrapperFrameFilter {...props} />
                </div>
            </WidgetPreview>
        );
    }
}

export default WfGrid
